module.exports = __webpack_public_path__ + "static/brown-48ef132e472b6a48bab678fa237d956b.png";